module.exports = __webpack_public_path__ + "media/images/new/icons/occupation-ad889da07f17b934092233f1292d1680.png";